// Styles
import '../css/main.css';
import '../css/responsive.css';

// Scripts
import './navigation';
import './gsap';
import './jquery.meanmenu';

// Ensure jQuery is passed to avoid global conflicts
(function ($) {
  "use strict";

  // Document ready
  $(document).ready(function () {

    // mean menu
    $(".menu-primary-menu-container").meanmenu({
      meanMenuContainer: ".main-navigation",
      meanScreenWidth: "1199",
      meanRevealPosition: "right",
    });

    // Initialize Select2 (robust per-element setup)
    if (typeof $.fn.select2 === 'undefined') {
      console.error('Select2 is not loaded. Please ensure the Select2 library is included.');
      return;
    }

    $(".destination-select").each(function () {
      // Clear any previously selected items on page load
      $(this).val('').trigger('change');

      var $el = $(this);

      // Determine if the underlying <select> is multiple; fall back to data attribute
      var isMultiple = $el.prop('multiple') || $el.data('multiple') === true;

      $el.select2({
        multiple: isMultiple,
        closeOnSelect: false,
        // allowClear only works for single-selects; keep consistent
        allowClear: !isMultiple,
        tags: true,
        placeholder: $el.data('placeholder') || '',
        // Token separators help when tags are used
        tokenSeparators: [',', '\n'],
        // Sanitize markup to avoid XSS while still allowing simple text
        escapeMarkup: function (markup) {
          return $('<div/>').text(markup).html();
        },
        templateResult: function (data) {
          if (!data || !data.text) return '';
          return $('<div/>').text(data.text).html();
        },
        templateSelection: function (data) {
          if (!data || !data.text) return '';
          return $('<div/>').text(data.text).html();
        }
      });

      // Ensure removal/unselect behavior is handled and triggers change events.
      // Some environments may fail to update underlying inputs without an explicit change trigger.
      $el.on('select2:unselect select2:unselecting', function (e) {
        // 'select2:unselect' fires after removal. Trigger change to ensure any listeners update.
        $(this).trigger('change');
      });
    });
    // $(".destination-select").select2({
    //   placeholder: "Destination",
    // });
    // $(".activities-select").select2({
    //   placeholder: "Activities",
    // });
    // $(".date-tour-select").select2({
    //   placeholder: "Choose a date",
    // });

    //top category slider
    const top_categories = new Swiper('.top-categories-slider-wrapper', {
      // Optional parameters
      loop: true,
      slidesPerView: 1,
      grabCursor: true,
      autoplay: true,
      breakpoints: {
        993: {
          slidesPerView: 4,
        },
        768: {
          slidesPerView: 3,
        },
        576: {
          slidesPerView: 2,
        }
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: false,
        clickable: true
      },


    });

    // review slider
    const review_slider = new Swiper('.reviews-slider-section', {
      // Optional parameters
      loop: true,
      slidesPerView: 1,
      grabCursor: true,
      // autoplay: true,
      spaceBetween: 30,
      breakpoints: {
        993: {
          slidesPerView: 1,
        },
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: false,
        clickable: true
      },

    });

    // package_slider
    const package_slider = new Swiper('.package-post-slider-section', {
      // Optional parameters
      loop: true,
      slidesPerView: 1,
      grabCursor: true,
      autoplay: true,
      spaceBetween: 30,
      breakpoints: {
        993: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 2,
        }
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

      pagination: {
        el: ".swiper-pagination",
        dynamicBullets: false,
        clickable: true
      },

    });

    // tour_gallery slider
    const tour_gallery_slider = new Swiper('.tour-gallery-slider-wrap', {
      // Optional parameters
      loop: true,
      slidesPerView: 1,
      grabCursor: true,
      autoplay: true,
      spaceBetween: 10,
      breakpoints: {
        993: {
          slidesPerView: 3,
        },
        480: {
          slidesPerView: 2,
        }
      },

      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },

    });

    //lightbox
    lightbox.option({
      'resizeDuration': 200,
      'wrapAround': true,
      'disableScrolling': true,
      // 'showImageNumberLabel': false,
    });

    // custom tab
    jQuery('.tabs .tab-links a').on('click', function (e) {
      var currentAttrValue = jQuery(this).attr('href');

      // Show/Hide Tabs
      jQuery('.tabs ' + currentAttrValue).fadeIn(400).siblings().hide();

      // Change/remove current tab to active
      jQuery(this).parent('li').addClass('active').siblings().removeClass('active');

      e.preventDefault();
    });

    //accordion
    $('.accordion-toggle').click(function (e) {
      e.preventDefault();

      var $this = $(this);

      $('.accordion-toggle').not(this).removeClass('new-show');
      $(this).toggleClass('new-show');

      if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(350);
      } else {
        $this.parent().parent().find('li .accordion-inner').removeClass('show');
        $this.parent().parent().find('li .accordion-inner').slideUp(350);
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
      }
    });

  });

})(jQuery);

jQuery(document).ready(function ($) {
  var $window = $(window);
  var $section = $('.reviews-section');
  var $imageItem = $('.reverse-reviews-image-item');

  // Duplicate content for seamless looping
  $imageItem.append($imageItem.html());

  var sectionTop = $section.offset().top;
  var sectionHeight = $section.outerHeight();
  var originalImageHeight = $imageItem.outerHeight() / 2;

  var scrollSpeed = 1.5; // Increased speed here
  var currentScroll = 0;
  var autoScrollStarted = false;
  var paused = false;

  function autoScroll() {
    if (!paused) {
      currentScroll += scrollSpeed;

      if (currentScroll >= originalImageHeight) {
        currentScroll = 0;
      }

      $imageItem.css('transform', 'translateY(-' + currentScroll + 'px)');
    }
    requestAnimationFrame(autoScroll);
  }

  function checkSectionInView() {
    var scrollTop = $window.scrollTop();
    var windowHeight = $window.height();

    if (scrollTop + windowHeight > sectionTop && scrollTop < sectionTop + sectionHeight) {
      if (!autoScrollStarted) {
        autoScrollStarted = true;
        autoScroll();
      }
    }
  }

  // Pause scroll on hover
  $imageItem.hover(
    function () {
      paused = true;
    },
    function () {
      paused = false;
    }
  );

  $window.on('scroll resize', checkSectionInView);
  checkSectionInView();

});

// for reverse
jQuery(document).ready(function ($) {
  var $window = $(window);
  var $section = $('.reviews-section');
  var $imageItem = $('.reviews-image-item');

  // Duplicate content for seamless loop
  $imageItem.append($imageItem.html());

  var sectionTop = $section.offset().top;
  var sectionHeight = $section.outerHeight();
  var originalImageHeight = $imageItem.outerHeight() / 2;

  var scrollSpeed = 1.5; // scroll speed
  var currentScroll = -originalImageHeight; // start from top of duplicated content
  var autoScrollStarted = false;
  var paused = false;

  function autoScroll() {
    if (!paused) {
      currentScroll += scrollSpeed;

      if (currentScroll >= 0) {
        currentScroll = -originalImageHeight;
      }

      $imageItem.css('transform', 'translateY(' + currentScroll + 'px)');
    }
    requestAnimationFrame(autoScroll);
  }

  function checkSectionInView() {
    var scrollTop = $window.scrollTop();
    var windowHeight = $window.height();

    if (scrollTop + windowHeight > sectionTop && scrollTop < sectionTop + sectionHeight) {
      if (!autoScrollStarted) {
        autoScrollStarted = true;
        autoScroll();
      }
    }
  }

  // Pause on hover
  $imageItem.hover(
    function () {
      paused = true;
    },
    function () {
      paused = false;
    }
  );

  $window.on('scroll resize', checkSectionInView);
  checkSectionInView();
});

// HERO SLIDER
var menu = [];
jQuery('.swiper-slide').each(function (index) {
  menu.push(jQuery(this).find('.slide-inner').attr("data-text"));
});
var interleaveOffset = 1;
var swiperOptions = {
  loop: true,
  speed: 1500,
  effect: 'fade',
  parallax: false,
  autoplay: true,
  // autoplay: {
  //   delay: 6500,
  //   disableOnInteraction: true,
  // },
  // watchSlidesProgress: true,
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },

  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  on: {
    progress: function () {
      var swiper = this;
      for (var i = 0; i < swiper.slides.length; i++) {
        var slideProgress = swiper.slides[i].progress;
        var innerOffset = swiper.width * interleaveOffset;
        var innerTranslate = slideProgress * innerOffset;
        swiper.slides[i].querySelector(".slide-inner").style.transform =
          "translate3d(" + innerTranslate + "px, 0, 0)";
      }
    },

    touchStart: function () {
      var swiper = this;
      for (var i = 0; i < swiper.slides.length; i++) {
        swiper.slides[i].style.transition = "";
      }
    },

    setTransition: function (speed) {
      var swiper = this;
      for (var i = 0; i < swiper.slides.length; i++) {
        swiper.slides[i].style.transition = speed + "ms";
        swiper.slides[i].querySelector(".slide-inner").style.transition =
          speed + "ms";
      }
    }
  }
};

var swiper = new Swiper(".swiper-container", swiperOptions);

// DATA BACKGROUND IMAGE
var sliderBgSetting = jQuery(".slide-bg-image");
sliderBgSetting.each(function (indx) {
  if (jQuery(this).attr("data-background")) {
    jQuery(this).css("background-image", "url(" + jQuery(this).data("background") + ")");
  }
});


